import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export interface RootState {}

export function createStore(modules?: { ns: string; subModule: any }[]) {
  const store = new Vuex.Store<RootState>({})

  if (modules) {
    for (const m of modules) {
      if (m.ns && m.subModule) {
        store.registerModule(m.ns, m.subModule)
      }
    }
  }

  return store
}
